import React, { useEffect, useState } from "react";
import * as configuration from "../../../components/DealerLocatorComponent/configuration/configuration";
import { swarovskiMapStyle } from "../../../components/DealerLocatorComponent/configuration/map-style";

export function useGoogleMapsWithHandle(
  isLoaded: boolean,
  opts: {
    mapElementRef: React.RefObject<HTMLDivElement | null>;
    apiKey: string;
  },
  googleMapOpts?: google.maps.MapOptions,
) {
  const [mapInstanceHandle, setMapInstanceHandle] = useState<google.maps.Map | null>(null);

  useEffect(() => {
    if (isLoaded && !mapInstanceHandle) {
      const currentMapElementRef = opts.mapElementRef.current;

      if (!currentMapElementRef) {
        console.log("No map element");
        return;
      }

      const optionsWithDefaults = {
        ...{
          zoom: 8,
          minZoom: configuration.MAP.minZoom,
          maxZoom: configuration.MAP.maxZoom,

          styles: swarovskiMapStyle,
          zoomControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        },
        ...(googleMapOpts || {}),
      };

      const map: google.maps.Map = new window.google.maps.Map(currentMapElementRef, optionsWithDefaults);

      setMapInstanceHandle(map);
    }
  }, [isLoaded, mapInstanceHandle, opts.mapElementRef]);

  useEffect(() => {
    if (!isLoaded && mapInstanceHandle) {
      setMapInstanceHandle(null);
    }
  }, [isLoaded]);

  return mapInstanceHandle;
}
